import { gql, useQuery } from "@apollo/client";

const FETCH_AI_CHAT_SESSIONS = gql`
query getAiChatSessions($userId: Int4, $sessionSource: Text) {
  aiChatSessions(where: {userId: {_eq: $userId}, sessionSource: {_eq: $sessionSource}}){
    sessionName
    id
  }
}
`;

const useFetchAiChatSessions = (userId, sessionSource) => {
    const { data, loading, error } = useQuery(FETCH_AI_CHAT_SESSIONS,
        {
            context: {
                headers: {
                    "x-hasura-role": "learner"
                }
            },
            variables: {
                userId: userId,
                sessionSource: sessionSource
            },
            skip: !userId || !sessionSource
        }
    );

    return { data: data?.aiChatSessions, loading, error };
}

export default useFetchAiChatSessions;